@use "../../../scss/settings/colors";

.add_button {
  font-family: 'Medium Inter', sans-serif;
  text-transform: none !important;
  font-size: 0.75rem;
  color: colors.$base-white !important;
  background-color: colors.$brand-purple !important;
  border: 1px solid colors.$brand-purple;
  border-radius: 8px;
  box-shadow: none;
  padding: 12px;
  height: 115px; // Match supplier_card height
  min-height: unset;
  margin: 0;
  transition: background-color 0.3s, color 0.3s, border-color 0.3s;

  &:hover {
    color: colors.$brand-purple !important;
    background-color: colors.$base-white !important;
    border-color: colors.$brand-purple;
    box-shadow: none;
  }

  &:global(.Mui-disabled):hover, &[disabled]:hover {
    color: colors.$base-white !important;
    background-color: colors.$brand-purple !important;
    border-color: colors.$brand-purple !important;
  }
}

.grid_margin_bottom {
  margin-bottom: 2em !important;
  padding-top: 0 !important;
}

.page_title {
  color: colors.$base-black;
  font-size: 26px;
}

.subheader {
  color: colors.$base-black;
  margin-top: 2rem !important;
}

.employee_card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: colors.$dark-blue !important;
  padding: 12px;
  width: 184px; // Fixed width
  height: 115px; // Fixed height
  cursor: pointer;
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden; // Prevent content overflow
}

.employee_card:hover {
  box-shadow: 0 8px 24px rgba(colors.$brand-purple, 0.15);
}

.employee_profile_icons {
  display: flex;
  flex-shrink: 0; // Icons won't shrink
  margin-top: auto; // Push to bottom
  svg {
    fill: colors.$gray-variant-11 !important;
  }
}

.employee_cards {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 2rem !important;
}

.form_box {
  position: absolute;
  z-index: 5;
  animation: pulse 0.5s ease-in-out;
  border-color: colors.$brand-purple;
}

.form_upload{
  border-color: colors.$brand-purple;
  margin-left: 32px;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

// Employee name text handling - matching customer solution
.employee_name {
  height: 50px;
  max-height: 50px; // Strict limit
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.875rem;
  line-height: 1.3;
  font-weight: 400;
  color: colors.$dark-blue;
  word-break: break-word;
  transition: all 0.3s ease;
  flex-shrink: 0; // Prevent shrinking
  
  &.long_text {
    font-size: 0.75rem;
  }
}